/**
 * @file useApp.js
 * Hook di accesso al contesto principale dell'applicazione (AppContext).
 * Fornisce un punto di accesso centralizzato alle funzionalità globali dell'app.
 */

import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

/**
 * Hook che espone il contesto globale AppContext.
 * Lancia un errore se usato fuori dall'AppProvider, per intercettare subito
 * errori di configurazione nell'albero dei componenti.
 * @returns {object} Il valore del contesto AppContext
 */
export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be inside AppProvider');
  return ctx;
}
